import React from 'react';
import { DATE_FORMATS, formatDateByFormat } from '../../../../../../../../utils/dateUtils';
import { WHATSAPP_TAG_LABEL } from '../../../../../../../../store/globalAskAica/whatsapp/constants';
import { WhatsAppChatSummary } from '../../../../../../../../store/globalAskAica/whatsapp/types';
import rowStyles from '../ConversationSidebar/PortfolioConversationSidebar.module.scss';
import styles from './WhatsAppChat.module.scss';

interface WhatsAppSidebarRowProps {
    chat: WhatsAppChatSummary;
    selected: boolean;
    disabled?: boolean;
    onOpen: (chatId: string) => void;
}

/** A WhatsApp row in the conversation sidebar: tagged, and deliberately without a delete control. */
const WhatsAppSidebarRow: React.FC<WhatsAppSidebarRowProps> = ({ chat, selected, disabled, onOpen }) => (
    <div className={`${rowStyles.Row} ${selected ? rowStyles.RowSelected : ''}`} data-testid="whatsapp-conversation-row">
        <button type="button" className={rowStyles.RowMain} onClick={() => onOpen(chat.chatId)} disabled={disabled}>
            <span className={rowStyles.RowTitle}>{chat.title}</span>
            <span className={styles.RowMeta}>
                <span className={styles.ChannelTag} data-testid="conversation-channel-tag">
                    {WHATSAPP_TAG_LABEL}
                </span>
                <span className={rowStyles.RowSubtitle}>{formatDateByFormat(chat.lastMessageAt, DATE_FORMATS.LIBRARY_FILE_TIMESTAMP)}</span>
            </span>
        </button>
    </div>
);

export default WhatsAppSidebarRow;
